// src/hooks/transportations/useGetTransportationsForSelect.js
import { useQuery } from "@tanstack/react-query";
import { getTransportationsForSelect } from "../../api/apiTransportations";
import i18next from "i18next";

const QUERY_KEY = ["transportations", "select", i18next.language];

const useGetTransportationsForSelect = () => {
    const {
        data,
        isLoading,
        isError,
        error,
    } = useQuery({
        queryKey: QUERY_KEY,
        queryFn: getTransportationsForSelect,
    });

    return {
        isLoading,
        error: isError ? error : null,
        transportations: data?.data || [],
    };
};

export default useGetTransportationsForSelect;
